module.exports = __webpack_public_path__ + "static/media/haechan-9.jpeg";